import { useQuery } from '@tanstack/react-query';
import { useSearchParams } from 'react-router-dom';

import API from 'configs/API';
import { createPersister } from 'react-query';

const useArtworks = (userUuid) => {
  const [searchParams] = useSearchParams();
  const objectParamsFromSearchParams = Object.fromEntries(searchParams);

  const params = {
    ...objectParamsFromSearchParams,
    user_uuid: userUuid,
  };

  return useQuery({
    queryKey: [API.ARTWORK.LIST_ARTWORK_EXCLUDING_SOLD_DONATED_GIFTED, params],
    persister: createPersister(),
  });
};

export default useArtworks;
